import React, { useEffect, useState } from 'react';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import { discountConlicitantes } from 'services/actions/discount_conlicitantes';
import { useLocation } from 'react-router-dom';
import { ButtonCard, Container, IconCustom } from './styles';

const Conlicitantes = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const utmParams = queryParams.toString();

  useEffect(() => {
    document.title = 'ConLicitantes - ConLicitação';
    if (profile?.in_sample || profile?.in_analysis) {
      window.location.href = '/painel';
    }
  }, []);

  const handleClick = async () => {
    setLoading(true);
    (async () => {
      const request = await discountConlicitantes();

      request?.data?.success && setLoading(false);
      if (request?.data?.success === true) {
        const encodedURL = `https://ingressos.conlicitantes.com.br/checkout/?code=${request?.data?.code}&${utmParams}`;
        window.location.href = encodedURL;
      } else if (request?.data?.success === false && request.status === 401) {
        window.location.href = '/recurso_inativo';
      }
    })();
  };

  return (
    <Container>
      <div className="page-container pb-5">
        <div className="container align-content-center">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center text-white page-title">
                <h2 className="pt-5 font-weight-bold">14, 15 e 16 de outubro</h2>
                <h1 className="mt-3">Um evento, múltiplas oportunidades</h1>
                <h5>
                  Transforme seu tempo em resultados, aprenda com os melhores e explore novas
                  oportunidades de sucesso.
                </h5>
              </div>
            </div>
          </div>
          <div className="d-flex mt-3 justify-content-center container-tickets">
            <div>
              <div className="d-flex custom-card sold-out list justify-content-center align-items-center">
                <div className="card-vip">
                  <div className="title-container justify-content-between">
                    <span className="bold-text text-white">INGRESSO VIP</span>
                    <span className="divider" />
                    <span className="light-text">ESGOTADO</span>
                  </div>
                  <hr className="horizontal-divider" />
                  <ul className="benefits">
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Acesso aos 3 dias de evento
                    </li>
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Acesso aos 3 Happy Hours
                    </li>
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Alimentação inclusa durante o evento
                    </li>
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Acesso às salas de trabalho remoto
                    </li>
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Acesso às gravações das palestras
                    </li>
                    <li>
                      <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                        done
                      </i>
                      Certificado de participação
                    </li>
                    <li>
                      <IconCustom className="material-icons mr-2 done" color="#9000FF">
                        done
                      </IconCustom>
                      Kit do participante VIP
                    </li>
                    <li>
                      <IconCustom className="material-icons mr-2 done" color="#9000FF">
                        done
                      </IconCustom>
                      Credenciamento exclusivo
                    </li>
                    <li>
                      <IconCustom className="material-icons mr-2 done" color="#9000FF">
                        done
                      </IconCustom>
                      Acesso às primeiras fileiras
                    </li>
                    <li>
                      <IconCustom className="material-icons mr-2 done" color="#9000FF">
                        done
                      </IconCustom>
                      Acesso à sala VIP
                    </li>
                  </ul>
                  <hr className="horizontal-divider" />
                  <div>
                    <p className="discount-badge">
                      Cliente ConLicitação <strong>20% OFF</strong>{' '}
                    </p>
                  </div>
                  <div className="py-2">
                    <span className="original-price">DE R$ 4.940,00</span>
                    <p className="final-price">
                      por <span>R$ 3.952,00</span>
                    </p>
                    <span className="payment-info">Em até 10x sem juros no cartão.</span>
                  </div>
                  <span className="sold-out-badge" aria-disabled="true">
                    ESGOTADO
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex custom-card sold-out list justify-content-center align-items-center">
                <div className="card-pass">
                  <div className="title-container justify-content-between">
                    <span className="bold-text text-white w-50">INGRESSO PASS</span>
                    <span className="divider" />
                    <span className="light-text">ESGOTADO</span>
                  </div>
                  <hr className="horizontal-divider" />
                  <div className="benefits">
                    <ul>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso aos 3 dias de evento
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso aos 3 Happy Hours
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Alimentação inclusa durante o evento
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso às salas de trabalho remoto
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso às gravações das palestras
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Certificado de participação
                      </li>
                      <li>
                        <IconCustom className="material-icons mr-2 close" color="#921174">
                          close
                        </IconCustom>
                        Kit do participante VIP
                      </li>
                      <li>
                        <IconCustom className="material-icons mr-2 close" color="#921174">
                          close
                        </IconCustom>
                        Credenciamento exclusivo
                      </li>
                      <li>
                        <IconCustom className="material-icons mr-2 close" color="#921174">
                          close
                        </IconCustom>
                        Acesso às primeiras fileiras
                      </li>
                      <li>
                        <IconCustom className="material-icons mr-2 close" color="#921174">
                          close
                        </IconCustom>
                        Acesso à sala VIP
                      </li>
                    </ul>
                  </div>
                  <hr className="horizontal-divider" />
                  <div>
                    <p className="discount-badge">
                      Cliente ConLicitação <strong>20% OFF</strong>{' '}
                    </p>
                  </div>
                  <div className="py-2">
                    <span className="original-price">DE R$ 3.690,00</span>
                    <p className="final-price">
                      por <span>R$ 2.952,00</span>
                    </p>
                    <span className="payment-info">Em até 10x sem juros no cartão.</span>
                  </div>
                  <span className="sold-out-badge" aria-disabled="true">
                    ESGOTADO
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex custom-card-on list justify-content-center align-items-center">
                <div className="card-on">
                  <div className="title-container justify-content-between justify-content-between">
                    <span className="bold-text text-white w-50">INGRESSO ONLINE</span>
                    <span className="divider" />
                    <span className="light-text">LOTE 2</span>
                  </div>
                  <hr className="horizontal-divider" />
                  <div className="benefits">
                    <ul>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso aos 3 dias de evento
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Acesso às gravações das palestras
                      </li>
                      <li>
                        <i className="material-icons mr-2 done" style={{ verticalAlign: 'middle' }}>
                          done
                        </i>
                        Certificado de participação
                      </li>
                    </ul>
                  </div>
                  <hr className="horizontal-divider" />
                  <div>
                    <p className="discount-badge">
                      Cliente ConLicitação <strong>15% OFF</strong>{' '}
                    </p>
                  </div>
                  <div className="py-2">
                    <span className="original-price">DE R$ 1.190,00</span>
                    <p className="final-price">
                      por <span>R$ 952,00</span>
                    </p>
                    <span className="payment-info">Em até 10x sem juros no cartão.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ButtonCard bgColor="#AD16F3" className="d-flex mt-5" onClick={() => handleClick()}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                {' Carregando...'}
              </>
            ) : (
              'GARANTIR INGRESSOS COM DESCONTO'
            )}
          </ButtonCard>
        </div>
      </div>
    </Container>
  );
};
export { Conlicitantes };
